import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sortByCreationTime',
    standalone: false
})
export class SortByCreationTimePipe implements PipeTransform {

 
  transform(appointments: any[]): any[] {
    return appointments.sort((a, b) => {
      let dateA = new Date(a.createdDate);
      let dateB = new Date(b.createdDate);

      return dateA.getTime() - dateB.getTime();
    });
  }

}
